import {memo, ReactNode} from 'react';
import styled from 'styled-components';
import {MOBILE_BREAKPOINT} from './constants';
import {TextHeading2, TextHeading4} from '../../index';

interface CardTitleProps {
  children: ReactNode;
  compressed?: boolean;
}

export const CardTitle = memo(
  ({children, compressed = false}: CardTitleProps) => {
    return (
      <TitleWrapper>
        {compressed ? (
          <TextHeading4 text={children as string} />
        ) : (
          <TextHeading2 text={children as string} />
        )}
      </TitleWrapper>
    );
  },
);

const TitleWrapper = styled.div`
  width: 80%;

  /* Mobile responsiveness */
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
  }
`;
